import script from "./ElementsMapping.vue?vue&type=script&lang=js"
export * from "./ElementsMapping.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__